<vi-loader
  data-at-loader
  *ngIf="
    (dataSearchState$ | async)?.loading && !(dataSearchState$ | async)?.loaded && !fetchLoading
  "
  [isLoading]="true"
  [message]="'+SEARCH.RESULT_LIST.LOADING' | translate"
></vi-loader>

<!-- users search results -->
<ng-container *ngIf="(activeSearch$ | async) === 'user'">
  <ng-container *ngIf="(search$ | async) === searchType.user">
    <app-users-search-results
      [dataState$]="dataSearchState$"
      [searchParams]="searchParams"
      (fetchNext)="setFetchNext()"
    ></app-users-search-results>
    <app-invitations-search-results
      *ngIf="!(dataSearchState$ | async).loading && searchParams?.companyNumber"
      [companyNumber]="companyNumber"
    ></app-invitations-search-results>
  </ng-container>
</ng-container>

<!-- errors search results -->
<ng-container *ngIf="(activeSearch$ | async) === 'error'">
  <ng-container *ngIf="(search$ | async) === searchType.error">
    <app-error-search-results [dataState$]="dataSearchState$"></app-error-search-results>
  </ng-container>
</ng-container>

<!-- gateways search results -->
<ng-container *ngIf="(activeSearch$ | async) === 'gateway'">
  <ng-container *ngIf="(search$ | async) === searchType.gateway">
    <app-gateways-search-results
      [dataState$]="dataSearchState$"
      [searchParams]="searchParams"
      (fetchNext)="setFetchNext()"
    ></app-gateways-search-results>
  </ng-container>

  <!-- installations search results -->
  <ng-container
    *ngIf="
      (search$ | async) === searchType.boiler &&
      (dataSearchState$ | async)?.loaded &&
      !(dataSearchState$ | async)?.loading
    "
  >
    <app-installations-search-results
      [dataState$]="dataSearchState$"
      [searchParams]="searchParams"
      (fetchNext)="setFetchNext()"
    ></app-installations-search-results>
  </ng-container>
</ng-container>
